<template>
  <main class="g-bg-attachment-fixed g-bg-white-opacity-0_1">
    <!-- Header v1 -->
    <header id="js-header" class="u-header u-header--sticky-top u-header--change-appearance"
            data-header-fix-moment="100">
      <div class="u-header__section u-header__section--dark g-bg-black-opacity-0_6 g-transition-0_3 g-py-20"
            data-header-fix-moment-exclude="g-bg-black-opacity-0_3 g-py-20"
            data-header-fix-moment-classes="g-bg-black-opacity-0_8 g-py-10">
        <nav class="navbar navbar-expand-lg py-0">
          <div class="container g-pos-rel">
            <!-- Logo -->
            <a href="/" class="js-go-to navbar-brand u-header__logo g-width-130 g-mr-60"
                data-type="static">
              <img class="img-fluid u-header__logo-img u-header__logo-img--main" src="/static/img/logoOpen.png" alt="Image Description">
            </a>
            <!-- End Logo -->

            <div id="navBar" class="collapse navbar-collapse w-100" data-mobile-scroll-hide="true">
              <!-- Navigation -->
              <div class="navbar-collapse align-items-center flex-sm-row">
                <ul id="js-scroll-nav" class="navbar-nav text-uppercase g-font-weight-700 g-font-size-13 g-py-20 g-py-0--lg">
                  <li class="nav-item g-mr-10--lg g-mr-15--xl g-my-7 g-mb-0--lg active">
                    <a href="#live" class="nav-link p-0">Live <span class="sr-only">(current)</span></a>
                  </li>
                  <li class="nav-item g-mx-10--lg g-mx-15--xl g-my-7 g-mb-0--lg">
                    <a href="#results" class="nav-link p-0">Résultats</a>
                  </li>
                  <li class="nav-item g-mx-10--lg g-mx-15--xl g-my-7 g-mb-0--lg">
                    <a href="#players" class="nav-link p-0">Joueurs</a>
                  </li>
                  <li class="nav-item g-mx-10--lg g-mx-15--xl g-my-7 g-mb-0--lg">
                    <a class="nav-link p-0" href="https://www.facebook.com/OPEN-DE-CAEN-131376730214870/"
                    target="_blank">
                        <i class="fa fa-facebook g-color-facebook"></i>
                    </a>
                  </li>
                  <li class="nav-item g-ml-10--lg g-ml-15--xl g-my-7 g-mb-0--lg">
                    <a href="https://twitter.com/opencaen" target="_blank" class="nav-link p-0">
                      <i class="fa fa-twitter g-color-twitter"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <!-- End Navigation -->
            </div>

            <!-- Responsive Toggle Button -->
            <button class="navbar-toggler btn g-line-height-1 g-brd-none g-pa-0 g-pos-abs g-top-5 g-right-0" type="button"
                    aria-label="Toggle navigation"
                    aria-expanded="false"
                    aria-controls="navBar"
                    data-toggle="collapse"
                    data-target="#navBar">
              <span class="hamburger hamburger--slider">
                <span class="hamburger-box">
                  <span class="hamburger-inner"></span>
                </span>
              </span>
            </button>
            <!-- End Responsive Toggle Button -->
          </div>
        </nav>
      </div>
    </header>
    <!-- End Header v1 -->

    <!-- Main Banner -->
    <section id="live" class="js-carousel g-overflow-hidden g-max-height-100vh"
      data-autoplay="false" data-accessibility="false"  data-pagi-classes="">
      <div class="js-slide">
        <!-- Promo Block -->
        <div class="g-flex-centered g-height-100vh g-min-height-500--md g-bg-cover g-bg-pos-center g-bg-img-hero">
          <div class="container text-center g-color-white g-z-index-1 g-bg-black-opacity-0_6 g-rounded-15" v-if="currentMatch">
            <div class="row">
              <div class="col-2">
                  <img class="img-fluid mx-auto d-block g-rounded-20" v-bind:src="getFace(currentMatch.player1.face)">
              </div>
              <div class="col-8">
                <h2 class="text-uppercase g-font-weight-700 g-font-size-default g-font-size-26--md g-font-size-36--lg">
                  {{currentMatch.player1.displayname}}<span> - </span>{{currentMatch.player2.displayname}}
                </h2>
                <br/>
                <div class="g-font-weight-500 g-font-size-default g-font-size-22--md g-font-size-32--lg g-mb-20">{{currentMatch.date | formatDate}} - {{currentMatch.round}}
                </div>
              </div>
              <div class="col-2">
                  <img class="img-fluid mx-auto d-block g-rounded-20" v-bind:src="getFace(currentMatch.player2.face)">
              </div>
            </div>
              <div>
                <table class="table g-font-weight-500 g-font-size-default g-font-size-24--md g-font-size-32--lg g-mb-10" v-if="currentMatch.startDate">
                  <thead>
                      <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>1</td>
                          <td>2</td>
                          <td>3</td>
                          <td>Pts</td>
                      </tr>
                  </thead>
                  <tbody>
                      <tr>
                          <td>
                            <img class="g-rounded-10 mx-auto country" v-bind:src="getCountryFlag(currentMatch.player1.country)">
                          </td>
                          <th class="text-left">{{currentMatch.player1.firstname}} {{currentMatch.player1.lastname}}</th>
                          <td>
                              <figure :class="getFlag(currentMatch,1)"></figure>
                          </td>
                          <td>{{currentMatch.sets[0].scorePlayer1}}</td>
                          <td>{{currentMatch.sets[1].scorePlayer1}}</td>
                          <td>{{currentMatch.sets[2].scorePlayer1}}</td>
                          <td>{{currentMatch.currentPointPlayer1}}</td>
                      </tr>
                      <tr>
                          <td>
                            <img class="g-rounded-10 mx-auto country" v-bind:src="getCountryFlag(currentMatch.player2.country)">
                          </td>
                          <th class="text-left">{{currentMatch.player2.firstname}} {{currentMatch.player2.lastname}}</th>
                          <td>
                              <figure :class="getFlag(currentMatch,2)"></figure>
                          </td>
                          <td>{{currentMatch.sets[0].scorePlayer2}}</td>
                          <td>{{currentMatch.sets[1].scorePlayer2}}</td>
                          <td>{{currentMatch.sets[2].scorePlayer2}}</td>
                          <td>{{currentMatch.currentPointPlayer2}}</td>
                      </tr>
                      <tr>
                          <td>
                              <a v-on:click="showStats(currentMatch.id)" class="btn btn-link">
                                <i class="fa fa-bar-chart" aria-hidden="true"></i>
                              </a>
                          </td>
                          <th class="text-left">{{getTotalDuration(currentMatch.startDate, currentMatch.endDate, currentMatch.currentDate)}}
                          </th>
                          <td></td>
                          <td> {{getDuration(currentMatch.sets[0].startDate, currentMatch.sets[0].endDate, currentMatch.currentDate)}}
                          </td>
                          <td> {{getDuration(currentMatch.sets[1].startDate, currentMatch.sets[1].endDate, currentMatch.currentDate)}}
                          </td>
                          <td> {{getDuration(currentMatch.sets[2].startDate, currentMatch.sets[2].endDate, currentMatch.currentDate)}}
                          </td>
                          <td></td>
                      </tr>
                  </tbody>
                </table>
              </div>
          </div>
          <div class="container text-center g-color-white g-z-index-1 g-bg-black-opacity-0_6 g-rounded-15" v-else>
            <h2>Coming Soon</h2>
          </div>
        </div>
        <!-- End Promo Block -->
      </div>
    </section>

    <section id="stats" class="g-pb-60" v-if="stats">
      <transition name="fade">
        <!-- Promo Block -->
        <div class="g-flex-centered g-height-100vh g-min-height-500--md g-bg-cover g-bg-pos-center g-bg-img-hero">
          <div class="container text-center g-color-white g-z-index-1 g-bg-black-opacity-0_6 g-rounded-15">
            <div class="row">
              <div class="col-2">
                <img class="img-fluid mx-auto d-block g-rounded-20" v-bind:src="getFace(stats[0].player.face)">
              </div>
              <div class="col-8">
                <h2 class="g-font-size-default g-font-size-24--md g-font-size-32--lg">
                  {{stats[0].player.displayname}}<span> - </span>{{stats[1].player.displayname}}
                </h2>
                <br/>
              </div>
              <div class="col-2">
                <img class="img-fluid mx-auto d-block g-rounded-20" v-bind:src="getFace(stats[1].player.face)">
              </div>
            </div>
            <div class="g-my-10 g-font-size-default g-font-size-18--md g-font-size-26--lg">
            <div class="row">
              <div class="col-3">
                  {{stats[0].ace}}
              </div>
              <div class="col-6">ACES</div>
              <div class="col-3">
                  {{stats[1].ace}}
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="progress">
                  <div class="progress-bar progress-reverse" role="progressbar" v-bind:style="{ width: getPercentage(stats[0].ace,stats[0].ace + stats[1].ace) +'%'}"></div>
                </div>
              </div>
              <div class="col-6">
                <div class="progress">
                  <div class="progress-bar" role="progressbar" v-bind:style="{ width: getPercentage(stats[1].ace,stats[0].ace + stats[1].ace) +'%'}"></div>
                </div>
              </div>
            </div>
            <div class="row">
                <div class="col-3">
                    {{stats[0].doubleFault}}
                </div>
                <div class="col-6">DOUBLES FAUTES
                </div>
                <div class="col-3">
                    {{stats[1].doubleFault}}
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar progress-reverse" role="progressbar" v-bind:style="{ width: getPercentage(stats[0].doubleFault,stats[0].doubleFault + stats[1].doubleFault) +'%' }">
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" v-bind:style="{ width: getPercentage(stats[1].doubleFault,stats[0].doubleFault + stats[1].doubleFault) +'%' }">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-3">
                    {{stats[0].firstServeIn}}
                </div>

                <div class="col-6">PREMIERS SERVICES
                </div>

                <div class="col-3">
                    {{stats[1].firstServeIn}}
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar progress-reverse" role="progressbar" v-bind:style="{ width: extractPercentage(stats[0].firstServeIn) +'%' }">
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" v-bind:style="{ width: extractPercentage(stats[1].firstServeIn) +'%' }">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-3">
                    {{stats[0].firstServeWon}}
                </div>

                <div class="col-6">POINTS GAGNES 1ER SERVICE
                </div>

                <div class="col-3">
                    {{stats[1].firstServeWon}}
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar progress-reverse" role="progressbar" v-bind:style="{ width: extractPercentage(stats[0].firstServeWon) +'%' }">
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" v-bind:style="{ width: extractPercentage(stats[1].firstServeWon) +'%' }">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-3">
                    {{stats[0].secondServeWon}}
                </div>

                <div class="col-6">POINTS GAGNES 2ND SERVICE
                </div>

                <div class="col-3">
                    {{stats[1].secondServeWon}}
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar progress-reverse" role="progressbar" v-bind:style="{ width: extractPercentage(stats[0].secondServeWon) +'%' }">
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" v-bind:style="{ width: extractPercentage(stats[1].secondServeWon) +'%' }">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-3">
                    {{stats[0].breakWon}}
                </div>

                <div class="col-6">BALLES DE BREAK
                </div>

                <div class="col-3">
                    {{stats[1].breakWon}}
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar progress-reverse" role="progressbar" v-bind:style="{ width: extractPercentage(stats[0].breakWon) +'%' }">
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" v-bind:style="{ width: extractPercentage(stats[1].breakWon) +'%' }">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-3">
                    {{stats[0].winners}}
                </div>

                <div class="col-6">POINTS GAGNANTS
                </div>

                <div class="col-3">
                    {{stats[1].winners}}
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar progress-reverse" role="progressbar" v-bind:style="{ width: getPercentage(stats[0].winners,stats[0].winners + stats[1].winners) +'%' }">
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" v-bind:style="{ width: getPercentage(stats[1].winners,stats[0].winners + stats[1].winners) +'%' }">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-3">
                    {{stats[0].unforcedErrors}}
                </div>

                <div class="col-6">FAUTES DIRECTES
                </div>

                <div class="col-3">
                    {{stats[1].unforcedErrors}}
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar progress-reverse" role="progressbar" v-bind:style="{ width: getPercentage(stats[0].unforcedErrors,stats[0].unforcedErrors + stats[1].unforcedErrors) +'%' }">
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" v-bind:style="{ width: getPercentage(stats[1].unforcedErrors,stats[0].unforcedErrors + stats[1].unforcedErrors) +'%' }">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-3">
                    {{stats[0].forcedErrors}}
                </div>

                <div class="col-6">FAUTES PROVOQUEES
                </div>

                <div class="col-3">
                    {{stats[1].forcedErrors}}
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar progress-reverse" role="progressbar" v-bind:style="{ width: getPercentage(stats[0].forcedErrors,stats[0].forcedErrors + stats[1].forcedErrors) +'%' }">
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" v-bind:style="{ width: getPercentage(stats[1].forcedErrors,stats[0].forcedErrors + stats[1].forcedErrors) +'%' }">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-3">
                    {{stats[0].totalPointWon}}
                </div>

                <div class="col-6">TOTAL POINTS GAGNES
                </div>

                <div class="col-3">
                    {{stats[1].totalPointWon}}
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar progress-reverse" role="progressbar" v-bind:style="{ width: getPercentage(stats[0].totalPointWon,stats[0].totalPointWon + stats[1].totalPointWon) +'%' }">
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" v-bind:style="{ width: getPercentage(stats[1].totalPointWon,stats[0].totalPointWon + stats[1].totalPointWon) +'%' }">
                        </div>
                    </div>
                </div>
            </div>
            </div>

          </div>
        </div>
      </transition>
    </section>
    <section id="results" class="g-pb-60" v-observe-visibility="reloadMatch">
      <div class="container">
        <div class="text-center g-color-white g-z-index-1 g-bg-black-opacity-0_6 g-rounded-15 g-mb-60">
          <h2>Résultats</h2>
        </div>
        <div class="row" v-if="matchList">
          <div class="g-my-5 col-md-6 col-12" v-for="match in matchList">
            <div class="text-center g-color-white g-z-index-1 g-bg-black-opacity-0_6 g-rounded-15 g-mb-10">
              <div class="row g-pa-10">
                <div class="col-2">
                    <img class="img-fluid mx-auto d-block g-rounded-20" v-bind:src="getFace(match.player1.face)">
                </div>
                <div class="col-8">
                  <h2 class="text-uppercase g-font-weight-700 g-font-size-default">
                    {{match.player1.displayname}}<span> - </span>{{match.player2.displayname}}
                  </h2>
                  <br/>
                  <div class="g-font-weight-500 g-font-size-default g-mb-10">{{match.date | formatDate}} - {{match.round}}
                  </div>
                </div>
                <div class="col-2">
                    <img class="img-fluid mx-auto d-block g-rounded-20" v-bind:src="getFace(match.player2.face)">
                </div>
              </div>
              <div class="g-mx-5">
                <table class="table g-font-weight-500 g-font-size-default g-mb-10" v-if="match.startDate">
                  <thead>
                      <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>1</td>
                          <td>2</td>
                          <td>3</td>
                          <td>Pts</td>
                      </tr>
                  </thead>
                  <tbody>
                      <tr>
                          <td>
                            <img class="g-rounded-10 mx-auto country" v-bind:src="getCountryFlag(match.player1.country)">
                          </td>
                          <th class="text-left">{{match.player1.firstname}} {{match.player1.lastname}}</th>
                          <td>
                              <figure :class="getFlag(match,1)"></figure>
                          </td>
                          <td>{{match.sets[0].scorePlayer1}}</td>
                          <td>{{match.sets[1].scorePlayer1}}</td>
                          <td>{{match.sets[2].scorePlayer1}}</td>
                          <td>{{match.currentPointPlayer1}}</td>
                      </tr>
                      <tr>
                          <td>
                            <img class="g-rounded-10 mx-auto country" v-bind:src="getCountryFlag(match.player2.country)">
                          </td>
                          <th class="text-left">{{match.player2.firstname}} {{match.player2.lastname}}</th>
                          <td>
                              <figure :class="getFlag(match,2)"></figure>
                          </td>
                          <td>{{match.sets[0].scorePlayer2}}</td>
                          <td>{{match.sets[1].scorePlayer2}}</td>
                          <td>{{match.sets[2].scorePlayer2}}</td>
                          <td>{{match.currentPointPlayer2}}</td>
                      </tr>
                      <tr>
                          <td>
                              <a v-on:click="showStats(match.id)" class="btn btn-link">
                                <i class="fa fa-bar-chart" aria-hidden="true"></i>
                              </a>
                          </td>
                          <th class="text-left">{{getTotalDuration(match.startDate, match.endDate, currentMatch.currentDate)}}
                          </th>
                          <td></td>
                          <td> {{getDuration(match.sets[0].startDate, match.sets[0].endDate, currentMatch.currentDate)}}
                          </td>
                          <td> {{getDuration(match.sets[1].startDate, match.sets[1].endDate, currentMatch.currentDate)}}
                          </td>
                          <td> {{getDuration(match.sets[2].startDate, match.sets[2].endDate, currentMatch.currentDate)}}
                          </td>
                          <td></td>
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
    <!-- Players Section -->
    <section id="players" class="g-pb-60">
        <div class="container">
          <div class="text-center g-color-white g-z-index-1 g-bg-black-opacity-0_6 g-rounded-15  g-mb-60">
            <h2>Joueurs</h2>
          </div>
          <div class="row" v-if="playerList">
            <div class="col-md-4 col-sm-6 g-mb-10" v-for="player in playerList">
              <article class="g-bg-black-opacity-0_6 g-rounded-15 text-center g-color-white">
                <img class="img-fluid mx-auto d-block g-rounded-20" :src="getFace(player.face)">

                <div class="g-pa-10">
                  <h3 class="text-uppercase g-font-weight-700 g-font-size-18">
                    {{player.firstname}} {{player.lastname}}
                  </h3>
                  <h4 class="text-uppercase g-font-weight-700 g-font-size-default">
                    {{player.country}}
                  </h4>
                  <ul class="list-inline team-social">
                      <li class="list-inline-item">
                          <a data-placement="top" data-toggle="tooltip" class="fb tooltips" data-original-title="Facebook" v-bind:href="player.facebook"
                          target="_blank">
                              <i class="fa fa-facebook"></i>
                          </a>
                      </li>
                      <li class="list-inline-item">
                          <a data-placement="top" data-toggle="tooltip" class="tw tooltips" data-original-title="Twitter" v-bind:href="player.twitter"
                          target="_blank">
                              <i class="fa fa-twitter"></i>
                          </a>
                      </li>
                      <li class="list-inline-item">
                          <a data-placement="top" data-toggle="tooltip" class="gp tooltips" data-original-title="Detail" v-bind:href="getCard(player.face)"
                          target="_blank">
                              <i class="fa fa-info"></i>
                          </a>
                      </li>
                  </ul>
                </div>
              </article>
            </div>
          </div>
        </div>
    </section>
    <!-- End Players Section -->
  </main>
</template>

<script>
export default {
  data () {
    return {
      matchList: undefined,
      playerList: undefined,
      currentMatch: undefined,
      stats: undefined,
      sponsorList: [
        {
          'name': 'villaeugene',
          'logo': 'villaeugene2.png',
          'link': 'http://villa-eugene.fr/'
        },
        {
          'name': 'fgprod',
          'logo': 'fgprod.png',
          'link': 'http://www.fg-productions.tv/'
        },
        {
          'name': 'jurzak',
          'logo': 'jurzak2.png',
          'link': 'http://www.jurzak-constructions.com/'
        },
        {
          'name': 'leclerc',
          'logo': 'leclerc.png',
          'link': 'http://www.e-leclerc.com/caen'
        },
        {
          'name': 'legallais',
          'logo': 'legallais.png',
          'link': 'https://www.legallais.com/'
        }
      ]
    }
  },
  created () {
    this.$socket.emit('getPlayers')
    this.$socket.emit('getMatchs')
    this.$socket.emit('getCurrentMatch')
  },
  sockets: {
    matchs (data) {
      if (data) {
        this.matchList = data
      }
    },
    displayMatch (data) {
      if (data) {
        this.currentMatch = data
      }
    },
    players (data) {
      if (data) {
        this.playerList = data
      }
    },
    stats (data) {
      if (data) {
        console.log('receive stat' + JSON.stringify(data))
        this.stats = data
      }
    }
  },
  methods: {
    reloadMatch: function () {
      this.$socket.emit('getMatchs')
    },
    showStats: function (matchId) {
      console.log('request stat' + matchId)
      this.$socket.emit('getStats', matchId)
    },
    getTotalDuration: function (startDate, endDate, currentDate) {
      if (startDate) {
        const sDate = new Date(startDate)
        const eDate = endDate ? new Date(endDate) : currentDate ? new Date(currentDate) : new Date()
        let duration = Math.round((eDate.getTime() - sDate.getTime()) / 1000)
        if (duration < 0) {
          duration = 0
        }
        let hours = Math.floor(duration / 3600)
        let minutes = Math.floor((duration - (hours * 3600)) / 60)

        if (minutes < 10) { minutes = '0' + minutes }
        return hours + ':' + minutes
      } else {
        return "0'"
      }
    },
    getDuration: function (startDate, endDate, currentDate) {
      if (startDate) {
        const sDate = new Date(startDate)
        const eDate = endDate ? new Date(endDate) : currentDate ? new Date(currentDate) : new Date()
        let duration = Math.round((eDate.getTime() - sDate.getTime()) / 1000)
        if (duration < 0) {
          duration = 0
        }
        let hours = Math.floor(duration / 3600)
        let minutes = Math.floor((duration - (hours * 3600)) / 60) + hours * 60

        return minutes + "'"
      } else {
        return "0'"
      }
    },
    getFlag: function (match, playerIndex) {
      if (!match || !match.flags) {
        return ''
      }
      if (match.flags.winnerId === playerIndex) {
        return 'flagWinner'
      } else if (match.flags.serverId === playerIndex) {
        var scoreServer = match.currentPointPlayer1
        var scoreOther = match.currentPointPlayer2
        if (match.flags.serverId === 2) {
          scoreServer = match.currentPointPlayer2
          scoreOther = match.currentPointPlayer1
        }
        if (scoreOther === 'A') {
          return 'flagBreak'
        }
        if (scoreOther === '40') {
          if (scoreServer !== '40' && scoreServer !== 'A') {
            return 'flagBreak'
          }
        }
        return 'flagBall'
      }
      return ''
    },
    getCountryFlag: function (country) {
      if (!country) {
        return ''
      } else {
        return 'static/img/country/' + country.toLowerCase() + '.gif'
      }
    },
    getFace: function (face) {
      if (!face) {
        return 'static/img/player/face/avatar.jpg'
      }
      return 'static/img/player/face/' + face.toLowerCase()
    },
    getCard: function (face) {
      if (face) {
        return '/static/img/player/card/' + face.toLowerCase().replace('png', 'jpg')
      }
    },
    getLogo: function (logo) {
      if (logo) {
        return 'static/img/sponsor/' + logo
      }
    },
    getPercentage: function (value, total) {
      if (!value || !total) {
        return 0
      }
      if (value <= 0) {
        return 0
      }
      if (value >= total) {
        return 100
      }
      return (value * 100) / total
    },
    extractPercentage: function (value) {
      if (!value) {
        return 0
      }
      var i = value.indexOf('%')
      if (i <= 0) {
        return value
      }
      return value.substring(0, i)
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Default.vue